type Props = {
    title: string,
    lineclass?:string
}
const GroupTitle = (props: Props) => {



    return (
        <div className="flex items-center justify-start relative">
            <div className={`h-[18px] border-[2px] rounded-full border-black  mr-[5px] ${props.lineclass}`} >

            </div>
            <div className="text-black text-base font-semibold ">{props.title}</div>
        </div>

    );
}
export default GroupTitle;